import React from 'react';

const PartnerResourceCardSkeleton: React.FC = () => {
  return (
    <div className="bg-white border border-[#F5F5F5] p-2 rounded-xl shadow-sm overflow-hidden relative">
      {/* Shimmer overlay */}
      <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none"></div>
      {/* Image Section Skeleton */}
      <div className="relative w-full h-48 bg-gradient-to-br from-gray-200 to-gray-300 rounded-xl animate-pulse">
        {/* Tag Skeleton */}
        <div className="absolute top-3 left-3">
          <div className="w-20 h-6 bg-gray-300/70 rounded-full"></div>
        </div>
        
        {/* Heart Icon Skeleton */}
        <div className="absolute top-3 right-3">
          <div className="w-6 h-6 bg-gray-300/70 rounded-full"></div>
        </div>
        
        {/* Image Navigation Dots Skeleton */}
        <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex gap-1">
          {[1, 2, 3].map((dot) => (
            <div
              key={dot}
              className="w-2 h-2 rounded-full bg-gray-300/70"
            />
          ))}
        </div>
      </div>

      {/* Content Section Skeleton */}
      <div className="p-4 bg-[#FAFAFA] h-auto min-h-[190px] mt-1 rounded-lg">
        {/* Logo and Name Skeleton */}
        <div className="flex items-start gap-3 mb-3">
          <div className="w-14 h-14 rounded-lg border border-[#E9E9E9] bg-gray-200/70 flex-shrink-0 animate-pulse"></div>
          <div className="flex flex-col flex-1 min-w-0 gap-2">
            <div className="flex items-center gap-2 min-w-0">
              <div className="h-5 bg-gray-200/70 rounded flex-1 animate-pulse"></div>
              <div className="w-12 h-4 bg-gray-200/70 rounded flex-shrink-0 animate-pulse"></div>
            </div>
            {/* Description Skeleton */}
            <div className="space-y-1 mt-1">
              <div className="h-3 bg-gray-200/70 rounded w-full animate-pulse"></div>
              <div className="h-3 bg-gray-200/70 rounded w-4/5 animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Details with Icons Skeleton */}
        <div className="space-y-2 mb-4">
          {/* Location Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-gray-200/70 rounded flex-shrink-0 animate-pulse"></div>
            <div className="h-4 bg-gray-200/70 rounded flex-1 animate-pulse"></div>
          </div>
          
          {/* Booking Plans Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-gray-200/70 rounded flex-shrink-0 animate-pulse"></div>
            <div className="h-4 bg-gray-200/70 rounded w-32 animate-pulse"></div>
          </div>
          
          {/* Kitchen Items Skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-gray-200/70 rounded flex-shrink-0 animate-pulse"></div>
            <div className="h-4 bg-gray-200/70 rounded w-28 animate-pulse"></div>
          </div>
        </div>

        {/* Price Skeleton */}
        <div className="mt-4 pt-4 border-t border-[#E9E9E9]">
          <div className="h-4 bg-gray-200/70 rounded w-24 animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default PartnerResourceCardSkeleton;

